var map = {
	"./versao2023": [
		7822,
		822
	],
	"./versao2023.jsx": [
		7822,
		822
	],
	"./versao2024": [
		4853,
		853
	],
	"./versao2024.jsx": [
		4853,
		853
	],
	"./versao2025": [
		5567,
		567
	],
	"./versao2025.jsx": [
		5567,
		567
	],
	"./versao2026": [
		46,
		46
	],
	"./versao2026.jsx": [
		46,
		46
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 737;
module.exports = webpackAsyncContext;